module.exports = __webpack_public_path__ + "static/media/16.4bbc448d.jpg";